<button
  [id]="'followButton' + record.id"
  *ngIf="!isMoreOption"
  class="accent transparent"
  mat-flat-button
  [class.waiting]="waiting"
  appStopPropagation
  (click)="doFollow()">
  <ng-container *ngIf="!waiting"> {{ (isFollower ? 'lists.unfollow' : 'lists.follow') | translate }} </ng-container>
  <mat-spinner *ngIf="waiting" [diameter]="20"></mat-spinner>
</button>
<button mat-menu-item *ngIf="isMoreOption" appStopPropagation (click)="doFollow()">
  <span class="odilo-icon" aria-hidden="true">{{ recordIcon }}</span>
  {{ (isFollower ? 'lists.unfollow' : 'lists.follow') | translate }}
</button>
